import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'a';
const idGen = new IDGenerator('wm_popover');

register('wm-popover', (): IBuildTaskDef => {
  return {
    template: (node: Element | any, shared: any) => { 
      if (node.children.length) {
        // If node has children, but an empty text node dont generate inlinecontent
        if (node.children.length === 1 && node.children[0] instanceof Text && (node.children[0] as any).value.trim().length === 0) {
          return;
        }
        shared.set('inlinecontent', node.children[0].value);
      }
    },
    pre: (attrs, shared: any) => {
      let inlinecontent = shared.get('inlinecontent');
      if(attrs.get('contentsource') === 'inline' && inlinecontent) {
        attrs.set('inlinecontent', inlinecontent);
      }
      const counter = idGen.nextUid();
      return `<${tagName} wmPopover  wmAnchor #${counter}="wmPopover" partialContainer ${getAttrMarkup(attrs)}>`;
    },
    post: () => `</${tagName}>`
  };
});

export default () => { };
